export default "__VITE_ASSET__d6ea79ce__"